<script lang="ts" setup>
// @ts-nocheck - Property 'index' does not exist on type '{ $: ComponentInternalInstance; $data: {}; $props: Partial<{}> & Omit<Readonly<ExtractPropTypes<__VLS_TypePropsToRuntimeProps<PagebuilderAccordionProps>>> & VNodeProps & AllowedComponentProps & ComponentCustomProps, never>; ... 10 more ...; $watch<T extends string | ((...args: any) => any)>(source: T, cb: T extends ...'.
import type { TabsDirection } from '~/components/tabs/Tabs.vue'

export interface TabsItem {
    data: {
        tab_field_name: string
        tab_field_type: TabsDirection
        html: string
        tab_field_primary_button: CTA
        tab_field_secondary_button: CTA
    }
}

export interface PagebuilderAccordionProps {
    data: {
        tab_field_type: 'horizontal' | 'vertical'
        tabs_repeater: Array<TabsItem>
    }
}
const props = defineProps<PagebuilderAccordionProps>()
const { $formatTableHtml } = useNuxtApp()
const links = reactive<Array<any>>(
    props.data.tabs_repeater.map((tab, index) => {
        return {
            name: tab.data.tab_field_name,
            id: `tab-${index}`,
        }
    })
)
</script>
<template>
  <!-- eslint-disable vue/no-v-html -->
  <Tabs
    :type="
      props.data.tab_field_type === 'vertical' ? 'tertiary' : 'primary'
    "
    :select-on-mobile="true"
    :direction="props.data.tab_field_type"
    :tabs-id="`PagebuilderTabs${props.data.tab_field_type}${props.data.tabs_repeater.length}`"
    :links="links"
  >
    <template
      v-for="(tab, index) in props.data.tabs_repeater"
      :key="index"
      #[`tab-panel-${index}`]
    >
      <article
        :class="{
          'rounded-4 bg-white box-shadow-1 p-4 p-lg-10':
            props.data.tab_field_type === 'vertical',
        }"
      >
        <Typo>
          <div v-html="$formatTableHtml(tab.data.html)" />
        </Typo>
        <div
          v-if="
            tab.data.tab_field_primary_button ||
              tab.data.tab_field_secondary_button
          "
          class="d-flex gap-4 mt-8"
        >
          <VButton
            v-if="tab.data.tab_field_primary_button"
            :target="
              tab.data.tab_field_primary_button.isExternal
                ? '_blank'
                : '_self'
            "
            :to="tab.data.tab_field_primary_button.link"
            color="primary"
          >
            {{ tab.data.tab_field_primary_button.text }}
          </VButton>
          <VButton
            v-if="tab.data.tab_field_secondary_button"
            :target="
              tab.data.tab_field_secondary_button.isExternal
                ? '_blank'
                : '_self'
            "
            :to="tab.data.tab_field_secondary_button.link"
            color="secondary"
          >
            {{ tab.data.tab_field_secondary_button.text }}
          </VButton>
        </div>
      </article>
    </template>
  </Tabs>
</template>
